import { createAction, props } from '@ngrx/store';
import { IExplorerProject } from '../../../interfaces/explorer/interfaces/IExplorerProject';
import { IWorkspaceProjectPaginated } from '../../../interfaces/workspace/IWorkspacePaginated';

export const createWorkspace = createAction(
  '[Workspace] Create Workspace',
  props<{ title: string; description: string; project_uuids: Array<string> }>()
);
export const createWorkspaceSuccess = createAction(
  '[Workspace] Create Workspace Success'
);

export const createWorkspaceFailure = createAction(
  '[Workspace] Create Workspace Failure',
  props<{ error: any }>()
);

export const loadProjectsForWorkspace = createAction(
  '[Workspace] Load Projects For Workspace'
);
export const loadProjectsForWorkspaceSuccess = createAction(
  '[Workspace] Load Projects For Workspace Success',
  props<{ projects: Array<IExplorerProject> }>()
);
export const loadProjectsForWorkspaceFailure = createAction(
  '[Workspace] Load Projects For Workspace Failure',
  props<{ error: any }>()
);

export const loadUserWorkspace = createAction(
  '[Workspace] Load User Workspace',
  props<{ page: number; size: number }>()
);

export const loadUserWorkspaceSuccess = createAction(
  '[Workspace] Load User Workspace Success',
  props<{ response: IWorkspaceProjectPaginated }>()
);

export const loadUserWorkspaceFailure = createAction(
  '[Workspace] Load User Workspace Failure',
  props<{ error: any }>()
);

export const deleteWorkspace = createAction(
  '[Workspace] Delete Workspace',
  props<{ uuid: string }>()
);

export const deleteWorkspaceSuccess = createAction(
  '[Workspace] Delete Workspace Success'
);

export const deleteWorkspaceFailure = createAction(
  '[Workspace] Delete Workspace Failure',
  props<{ error: any }>()
);

export const inviteNewMemberToWorkspace = createAction(
  '[Workspace] Invite New Member To Workspace',
  props<{
    email: string;
    permission_type: 'viewer' | 'editor' | 'admin';
    workspaceUUID: string;
  }>()
);

export const inviteNewMemberToWorkspaceSuccess = createAction(
  '[Workspace] Invite New Member To Workspace Success'
);

export const inviteNewMemberToWorkspaceFailure = createAction(
  '[Workspace] Invite New Member To Workspace Failure',
  props<{ error: any }>()
);

export const acceptOrRefuseInviteToWorkspace = createAction(
  '[Workspace] Accept Or Refuse Invite To Workspace',
  props<{ workspaceUUID: string; accepted: boolean }>()
);

export const acceptOrRefuseInviteToWorkspaceSuccess = createAction(
  '[Workspace] Accept Or Refuse Invite To Workspace Success'
);

export const acceptOrRefuseInviteToWorkspaceFailure = createAction(
  '[Workspace] Accept Or Refuse Invite To Workspace Failure',
  props<{ error: any }>()
);
export const editTitleWorkspace = createAction(
  '[Workspace] Edit Title Workspace',
  props<{ workspaceUUID: string; title: string }>()
);

export const editTitleWorkspaceSuccess = createAction(
  '[Workspace] Edit Title Workspace Success'
);

export const editTitleWorkspaceFailure = createAction(
  '[Workspace] Edit Title Workspace Failure',
  props<{ error: any }>()
);
export const removeUserFromWorkspace = createAction(
  '[Workspace] Remove User From Workspace',
  props<{ workspaceUUID: string; userUUID: string }>()
);
export const removeUserFromWorkspaceSuccess = createAction(
  '[Workspace] Remove User From Workspace Success'
);
export const removeUserFromWorkspaceFailure = createAction(
  '[Workspace] Remove User From Workspace Failure',
  props<{ error: any }>()
);

export const editUserPermissionFromWorkspace = createAction(
  '[Workspace] Edit User Permission From Workspace',
  props<{ workspaceUUID: string; userUUID: string; permission_type: 'viewer' | 'editor' | 'admin' }>()
);

export const editUserPermissionFromWorkspaceSuccess = createAction(
  '[Workspace] Edit User Permission From Workspace Success'
);
export const editUserPermissionFromWorkspaceFailure = createAction(
  '[Workspace] Edit User Permission From Workspace Failure',
  props<{ error: any }>()
);

export const checkPendingInvites = createAction(
  '[Workspace] Check Pending Invites',
);

export const checkPendingInvitesSuccess = createAction(
  '[Workspace] Check Pending Invites Success',
);

export const checkPendingInvitesFailure = createAction(
  '[Workspace] Check Pending Invites Failure',
  props<{ error: any }>()
);